import { activateInlineScripts } from '@otto-ec/global-resources/dom';

type LoadRecommendationsParams = {
    successViewElement: Pick<HTMLElement, 'querySelector'>;
    eventMergeId: string;
};

export const loadRecommendations = async ({ successViewElement, eventMergeId }: LoadRecommendationsParams): Promise<void> => {
    try {
        const recommendationsWrapper = successViewElement.querySelector<HTMLElement>('.js_cr_submission-page__recommendations');
        if (!recommendationsWrapper) return;

        const response = await fetch(`/reco-core/cinemas/emptybasket?eventMergeId=${eventMergeId}`);
        if (!response.ok) return;

        recommendationsWrapper.innerHTML = await response.text();

        await activateInlineScripts(recommendationsWrapper);
    } catch {
        /*                                                                         */
    }
};
